module.exports = __webpack_public_path__ + "static/img/swiper_bg.8477a4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/feature/swiper_bg.jpg
// module id = wXlZ
// module chunks = 7